import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import OpenView from '../views/OpenView.vue'
import AboutCompany from "../views/AboutCompany.vue"
import ConnectionView from "../views/ConnectionView.vue"
import ReferencesView from "../views/References.vue"
import Gallery from "../views/Galery.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'open',
    component: OpenView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/company',
    name: 'company',
    component: AboutCompany
  },
  {
    path: '/references',
    name: 'references',
    component: ReferencesView
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: Gallery
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/connection',
    name: 'connection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ConnectionView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
